import { Translations, UnitsLocale } from "./locales/locale";
import { captureError } from "../error-tracking";
import { getLocale, locales } from "./locale";

export const translate = (key: string, ...variables: string[]): string => {
  const locale = getLocale();
  // console.log('Current locale in translate:', locale); // 语言翻译调试输出
  const translations = locales[locale].translations;
  // console.log('Available locales:', Object.keys(locales)); // 语言翻译调试输出
  const template = translations[key as keyof Translations];
  if (!template) {
    captureError(new Error(`Missing translation for ${key}`));
    return key;
  }

  const text = compileText(template, variables);
  return text;
};

export const translateUnit = (key: string): string => {
  const locale = getLocale();
  const units = locales[locale].units;

  const text = units[key as keyof UnitsLocale];
  if (!text) {
    captureError(new Error(`Missing unit locale for ${key}`));
  }

  return text || key;
};

const compileText = (template: string, variables: string[]): string => {
  console.log('Template:', template, 'Variables:', variables); // 添加调试
  let result = template;
  variables.forEach((variable, i) => {
    result = result.replace(`$\{${i + 1}}`, variable);
  });
  console.log('Result:', result); // 添加调试
  return result;
};

export { parseLocaleNumber, reformatWithoutGroups } from "./locale-number";
export { localizeKeybinding } from "./mac";
